import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { captainLabel } from '@utils/constants';


@Component({
  selector: 'oamw-confirm-isi',
  templateUrl: './confirm-isi.component.html',
  styleUrls: ['./confirm-isi.component.scss']
})
export class ConfirmIsiPage implements OnInit {

  isTermsChecked = false;
  captainLabel: string;



  constructor(private router: Router) { 
    this.captainLabel = captainLabel;
  }

  ngOnInit(): void {
    if(navigator.platform.match('Mac') !== null) {
      document.getElementById('confirmIsi').classList.add('mac-isi');
    }
  }

  confirmIsiRead() {
    this.router.navigate(['start-session']);
  }

}
